import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Modal } from 'semantic-ui-react';

import StatefulModal from '../../../Components/Modal/StatefulModal';

import CreateEditPopupForm from './CreateEditPopupForm';

export default class AddPopupModal extends Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    isView: PropTypes.bool,
    isOpen: PropTypes.bool,
    trigger: PropTypes.element,
    announcementId: PropTypes.string,
    variables: PropTypes.object,
  };
  static defaultProps = {
    isEdit: false,
    isView: false,
  };
  render() {
    const { variables, isEdit, isView, trigger, announcementId } = this.props;
    return (
      <StatefulModal trigger={trigger} dimmer="inverted">
        {(closeModal) => (
          <Fragment>
            <Modal.Header>
              {isEdit ? 'Edit Pop-up' : isView ? 'View Pop-up' : 'Create New Pop-up'}
            </Modal.Header>
            <Modal.Content>
              <CreateEditPopupForm
                isEdit={isEdit}
                isView={isView}
                onComplete={closeModal}
                onCancelled={closeModal}
                searchVariables={variables}
                announcementId={announcementId}
              />
            </Modal.Content>
          </Fragment>
        )}
      </StatefulModal>
    );
  }
}
